export const en = {
  copy: 'Copy',
  copied: 'Copied',
  generatePdf: 'Generate pdf',
  openPdfInNewTab: 'Open PDF in new tab',
  seeMore: 'See More',
  seeLess: 'See Less',
  openLinkInNewTab: 'Open Link in new tab',
};
